import script from "./ProductSafetyAdditionalInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductSafetyAdditionalInfo.vue?vue&type=script&setup=true&lang=js"

import "./ProductSafetyAdditionalInfo.vue?vue&type=style&index=0&id=1129cfe4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1129cfe4"]])

export default __exports__